import { render, staticRenderFns } from "./aiMaterial.vue?vue&type=template&id=1df63a40&scoped=true&"
import script from "./aiMaterial.vue?vue&type=script&lang=js&"
export * from "./aiMaterial.vue?vue&type=script&lang=js&"
import style0 from "./aiMaterial.vue?vue&type=style&index=0&lang=less&"
import style1 from "./aiMaterial.vue?vue&type=style&index=1&id=1df63a40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df63a40",
  null
  
)

component.options.__file = "aiMaterial.vue"
export default component.exports